import styled from 'styled-components'

export const SectionSubHeading = styled.div`
  font-size: 24px;
  margin: 24px 0 16px;
`